import { Link } from 'react-router-dom';

export default function PageNotFound() {
  return (
    <main className="min-h-screen bg-[#F8F4EC] text-[#1A1814] flex items-center justify-center px-5">
      <div className="max-w-[560px] text-center">
        <div className="font-mono-label text-[10px] sm:text-[11px] text-[#C5A059] mb-8 flex items-center justify-center gap-3">
          <span aria-hidden className="block w-8 h-px bg-[#C5A059]/60" />
          404
          <span aria-hidden className="block w-8 h-px bg-[#C5A059]/60" />
        </div>
        <h1
          className="font-display text-[#1A1814] mx-auto"
          style={{ fontSize: 'clamp(32px, 5vw, 56px)', lineHeight: 1.05, letterSpacing: '-0.028em', textWrap: 'balance', fontWeight: 700, maxWidth: '18ch' }}
        >
          This page wandered off the{' '}
          <span style={{ color: '#C5A059' }}>itinerary.</span>
        </h1>
        <p className="text-[#3F3A30] mt-6 mx-auto max-w-[46ch]" style={{ fontSize: '17px', lineHeight: 1.6 }}>
          The page you were looking for is not here. Everything worth seeing is one step back, on the home page or in the worlds we design.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="group inline-flex w-full sm:w-auto items-center justify-center px-8 sm:px-10 py-4 bg-[#0A1A2F] text-[#F8F4EC] text-[13px] font-semibold tracking-[0.18em] uppercase rounded-sm hover:bg-[#C5A059] transition-colors duration-300"
          >
            <span>Back to the home page</span>
            <span aria-hidden className="ml-3 transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
          <Link
            to="/worlds"
            className="inline-flex w-full sm:w-auto items-center justify-center px-8 py-4 text-[13px] font-semibold tracking-[0.18em] uppercase text-[#0A1A2F] border border-[#0A1A2F]/20 rounded-sm hover:border-[#C5A059] hover:text-[#C5A059] transition-colors duration-300"
          >
            See the worlds we design
          </Link>
        </div>
      </div>
    </main>
  );
}
